import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { toast } from "../components/modern-ui/sonner";
import { validateCartAvailability } from "../store/slices/cart/asyncThunks";

// Isti toast id na oba mesta gde se provera pokreće (start aplikacije i ulazak
// u korpu) — ako se pozivi preklope, korisnik ne dobija dve iste poruke.
const TOAST_ID = "cart-unavailable-items";

/*
 * Izbacuje iz korpe proizvode koji više nisu u prodaji i javlja korisniku
 * šta je uklonjeno. Korpa se čuva u localStorage-u, pa stavka preživi
 * gašenje proizvoda — bez ove provere kupac vidi i poručuje nešto što se
 * više ne prodaje.
 *
 * Ako provera padne (nema mreže), korpa se namerno ne dira: backend svakako
 * odbija porudžbinu sa nedostupnim proizvodom.
 */
export default function useCartAvailabilityCheck() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(validateCartAvailability())
      .unwrap()
      .then(({ removedNames }) => {
        if (!removedNames?.length) return;
        toast.error(
          removedNames.length === 1
            ? `Proizvod „${removedNames[0]}" više nije dostupan i uklonjen je iz korpe.`
            : `${removedNames.length} proizvoda više nije dostupno i uklonjeni su iz korpe.`,
          { id: TOAST_ID },
        );
      })
      .catch(() => {});
  }, [dispatch]);
}
